"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResultPaginationLoadMore = void 0;

var react_1 = __importDefault(require("react"));

var hooks_1 = require("../../hooks");

var components_1 = require("../../components");

var ResultPaginationLoadMore = function ResultPaginationLoadMore(props) {
  var _a;

  var paginationLoadMoreHook = (0, hooks_1.usePaginationLoadable)(props);
  var RenderPaginationComponent = (_a = props.render) !== null && _a !== void 0 ? _a : components_1.ExampleResultPaginationLoadMore;
  return react_1.default.createElement(RenderPaginationComponent, Object.assign({}, paginationLoadMoreHook));
};

exports.ResultPaginationLoadMore = ResultPaginationLoadMore;